import React from 'react';
import { useHistory } from 'react-router-dom';
import Header from './components/Header';
import LandingPage from './components/pages/LandingPage';
import SurveyPage from './components/pages/SurveyPage';
import SummaryPage from './components/pages/SummaryPage';
import Footer from './components/Footer';
import classnames from 'classnames';
import { GuideAppContainer, logout, RenderOnlyFor, useNeuroState, usePages, PageContainer, useGuideConfig, Timeout } from "@ignitesales/neuro-application";

const AppBase = () => {
  const history = useHistory();
  const { isLoadingNextPage, isAnimatingPages } = usePages();
  const { user } = useNeuroState();
  const { isBranchGuide } = useGuideConfig();
  
  const bemClass = 'pageContainer';
  const contentClasses = classnames(`${bemClass}`, {
    [`${bemClass}__branch`]: isBranchGuide,
    [`${bemClass}__online`]: !isBranchGuide,
  });

  const timeoutMinutes = 45;

  const onIdleTimeout = () => {
    history.push('/guide');
    history.go('/guide');
  };

  return (<>
    <Timeout
        timeout={timeoutMinutes * 60000}
        onIdle={onIdleTimeout}
      />
    <GuideAppContainer>
      <Header processingNavigation={isLoadingNextPage || isAnimatingPages} />
      <PageContainer
        LandingPage={LandingPage}
        SurveyPage={SurveyPage}
        SummaryPage={SummaryPage}
        DetailsPage={SummaryPage} //TODO: does fcw not have a details page???
        className={contentClasses}
      />
      <RenderOnlyFor forLandingPage={true} forSummaryPage={true} forDetailsPage={true}>
        <Footer logout={logout} user={user}/>
      </RenderOnlyFor>
    </GuideAppContainer>
  </>);
};

export default AppBase;
